$.fn.fixer_zoom_compensator = function fixerZoomCompensator() {
  const el = $(this)

  if (!el.length) {
    return
  }

  let elLeftPosition = el.offset().left

  $(window).on("resize", () => {
    elLeftPosition = el.offset().left
  })

  $(document).on("fixer", () => {
    const pageXOffset = window.pageXOffset

    if (pageXOffset > 0) {
      window.HB.Memo.css(
        el,
        "fixer_zoom_compensator",
        "left",
        elLeftPosition - pageXOffset,
      )
    } else {
      window.HB.Memo.css(el, "fixer_zoom_compensator", "left", "")
    }
  })
}
